import Button from '@material-ui/core/Button';
import {  withStyles } from '@material-ui/core/styles';
import { orange, blue } from '@material-ui/core/colors';

export const OrangeButton = withStyles((theme) => ({
    root: {
    //   color: theme.palette.getContrastText(orange[500]),
      backgroundColor: '#f19a4e',
      '&:hover': {
        backgroundColor: '#ed883d',
      },
    },
  }))(Button);


  export const GreenButton = withStyles((theme) => ({
    root: {
    //   color: theme.palette.getContrastText(orange[500]),
      backgroundColor: '#54b9a4',
      '&:hover': {
        backgroundColor: '#43AA92',
      },
    },
  }))(Button);

  export const BlueButton = withStyles((theme) => ({
    root: {
    //   color: theme.palette.getContrastText(orange[500]),
      backgroundColor: blue[500],
      '&:hover': {
        backgroundColor: blue[700],
      },
    },
  }))(Button);